import type { IDoctor, ServiceData } from '../../EastclinicVueApi';
export default function (doctor:IDoctor):ServiceData|undefined {
  if (doctor.seoServiceData?.[0]) { return doctor.seoServiceData[0]; }
  if (doctor.choosen_service_data?.[0]) { return doctor.choosen_service_data[0]; }
  if (doctor.service_data?.[0]) { return doctor.service_data[0]; }
}
